/**
 * ADR-0213 Part 2 (spec §4.2, ruling 20) — the People panel's reach line, drawn
 * from `GET /tenant/admin/users/:accountId/effective-model` and nothing else:
 *
 *   "Reaches ‹n› objects. ‹m› columns restricted."
 *   "Reaches any view. ‹m› columns restricted."   (Query beyond the model)
 *   "Reaches no data."
 *
 * The console computes no reach of its own; it counts what the hub served.
 */

export interface EffectiveModelObject {
  name: string;
  area_names: string[];
  restricted_columns: string[];
}

export interface EffectiveModel {
  beyond_model: boolean;
  objects: EffectiveModelObject[];
}

const count = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export function reachLine(model: EffectiveModel): string {
  const restricted = model.objects.reduce((n, o) => n + o.restricted_columns.length, 0);
  const columns = `${count(restricted, "column", "columns")} restricted.`;
  if (model.beyond_model) return `Reaches any view. ${columns}`;
  if (model.objects.length === 0) return "Reaches no data.";
  return `Reaches ${count(model.objects.length, "object", "objects")}. ${columns}`;
}
